import { useEffect, useState } from 'react';
import { StyAlert, StyAlertTitle, StyContainer, StyToast } from './styles';
import { useTheme } from 'styled-components';
import { Typography } from '../Typography';

type TSeverity = 'success' | 'error' | 'warning' | 'info';

interface IToast {
  id: number;
  title?: string;
  description?: string;
  severity: TSeverity;
}

interface ToastInfo {
  id: number;
  title?: string;
  description?: string;
  severity: TSeverity;
}

export const Toast: React.FC<IToast> = ({
  id,
  title,
  description,
  severity,
}) => {
  const theme = useTheme();
  const [toastArray, setToastArray] = useState<ToastInfo[]>([]);
  const [closingToasts, setClosingToasts] = useState<number[]>([]);

  function handleClose(id: number) {
    setClosingToasts((prev) => [...prev, id]);
    setTimeout(() => {
      setToastArray((prevToastArray) =>
        prevToastArray.filter((toast) => toast.id !== id)
      );
      setClosingToasts((prev) => prev.filter((closingId) => closingId !== id));
    }, 400);
  }

  useEffect(() => {
    if (id && (title || description) && severity) {
      const newToast: ToastInfo = {
        id: id,
        title,
        description,
        severity,
      };

      setToastArray((prevToastArray) => [...prevToastArray, newToast]);
      setTimeout(() => {
        handleClose(newToast.id);
      }, 6000);
    }
  }, [id, title, description, severity]);

  const mapColor = {
    success: theme.green,
    warning: theme.yellow,
    error: theme.red,
    info: theme.blue,
  };

  return (
    <StyContainer>
      {toastArray.map((toastInfo) => (
        <StyToast
          key={`toast-${toastInfo.id}`}
          $isOpen={!closingToasts.includes(toastInfo.id)}
          color={mapColor[toastInfo.severity]}
        >
          <StyAlert
            onClose={() => handleClose(toastInfo.id)}
            closeText="Fechar"
            severity={toastInfo.severity}
          >
            {toastInfo?.title && (
              <StyAlertTitle $hasDescription={!!toastInfo?.description}>
                {toastInfo.title}
              </StyAlertTitle>
            )}
            {toastInfo?.description && (
              <Typography.Label size="small" color="neutral.500">
                {toastInfo.description}
              </Typography.Label>
            )}
          </StyAlert>
        </StyToast>
      ))}
    </StyContainer>
  );
};
